<template>
  <DataIterat
    :headless="fetching"
    :searchable="searchable"
    :filterable="filterable"
    :filter-presets="filterPresets"
    :actionable="actionable"
    :bulk-actionable="bulkActionable"
    :paginatable="meta && meta.last_page !== 1"
    :items="products"
    :loading="fetching"
    :meta="meta"
    v-on="{ getData: doGetProducts }"
  >
    <DataIteratHeaderContent slot="list-header-content" />
    <DataIteratItemContent
      slot="list-item-content"
      slot-scope="{ dataItem }"
      v-bind="{ product: dataItem }"
      :product-route-name="productRouteName"
    />
  </DataIterat>
</template>

<script>
import DataIterat from '@/components/Ui/DataIterat.vue';
import DataIteratHeaderContent from './DataIteratHeaderContent.vue';
import DataIteratItemContent from './DataIteratItemContent.vue';

export default {
  name: 'ProductList',
  components: {
    DataIterat,
    DataIteratHeaderContent,
    DataIteratItemContent,
  },
  props: {
    fetching: Boolean,
    searchable: Boolean,
    filterable: Boolean,
    filterPresets: {
      type: Array,
      default: () => [],
    },
    actionable: Boolean,
    bulkActionable: Boolean,
    products: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
    productRouteName: {
      type: String,
      required: true,
    },
  },
  methods: {
    doGetProducts(queryParams = {}) {
      this.$emit('get-products', queryParams);
    },
  },
};
</script>
